import EntityReportProfitLoss from "platform/presentation/entity/report/ProfitLossStatement";
import EntityReportBalanceSheet from "platform/presentation/entity/report/BalanceSheet";

const routes = [
  {
    path: "/entity/:legalEntityUUID/report/profit-loss",
    name: "Entity",
    icon: "ni ni-tv-2 text-primary",
    component: () => <EntityReportProfitLoss />,
    layout: "/presentation",
  },
  {
    path: "/entity/:legalEntityUUID/report/balance-sheet",
    name: "Entity",
    icon: "ni ni-tv-2 text-primary",
    component: () => <EntityReportBalanceSheet />,
    layout: "/presentation",
  },
];

export default routes;
